import { render, staticRenderFns } from "./pageIdConfig.vue?vue&type=template&id=ba1cfc28"
import script from "./pageIdConfig.vue?vue&type=script&lang=js"
export * from "./pageIdConfig.vue?vue&type=script&lang=js"
import style0 from "./pageIdConfig.vue?vue&type=style&index=0&id=ba1cfc28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports